export default __webpack_public_path__ + "acae8d893f2bb808d04e15ca333e656b.png";